/**
 * 사용자 주석 — 편집기 글에서 값과 그 값이 걸린 컬럼을 읽는 순수 함수(docs/features/32-user-comment.md).
 */

/** 'A01' → A01, '' 안의 '' 는 ' 하나. 따옴표가 없으면 그대로(앞뒤 공백만 뗀다) */
export function unquoteValue(text) {
    const s = String(text == null ? '' : text).trim();
    if (s.length >= 2 && s[0] === "'" && s[s.length - 1] === "'") return s.slice(1, -1).replace(/''/g, "'");
    if (s.length >= 2 && s[0] === '"' && s[s.length - 1] === '"') return s.slice(1, -1);
    return s;
}

/**
 * 값 바로 앞의 컬럼 — `a.CUST_STAT_CD = '01'` · `STATUS IN ('A', ` · `x <> 3` 의 컬럼 이름(별칭은 뗀다).
 * 못 찾으면 null — 그때는 모든 영역에서 찾는다.
 */
export function columnBeforeValue(textBefore) {
    const s = String(textBefore || '').slice(-400);
    const re = /([A-Za-z0-9_$#\u3131-\uD79D."]+)\s*(?:=|<>|!=|\^=|>=|<=|>|<|\bnot\s+in\s*\([^()]*|\bin\s*\([^()]*|\bnot\s+like|\blike)\s*$/i;
    const m = s.match(re);
    if (!m) return null;
    const parts = m[1].split('.').filter(Boolean);
    const last = parts.length ? parts[parts.length - 1].replace(/"/g, '') : '';
    return last || null;
}
